
    import './styles.scoped.css';
    export default {
  "icon": "awsui_icon_k5dlb_1qnfo_94",
  "top-navigation": "awsui_top-navigation_k5dlb_1qnfo_112",
  "padding-box": "awsui_padding-box_k5dlb_1qnfo_123",
  "medium": "awsui_medium_k5dlb_1qnfo_133",
  "narrow": "awsui_narrow_k5dlb_1qnfo_133",
  "virtual": "awsui_virtual_k5dlb_1qnfo_144",
  "hidden": "awsui_hidden_k5dlb_1qnfo_148",
  "\t": "awsui_\t_k5dlb_1qnfo_1",
  "identity": "awsui_identity_k5dlb_1qnfo_160",
  "identity-link": "awsui_identity-link_k5dlb_1qnfo_163",
  "no-logo": "awsui_no-logo_k5dlb_1qnfo_180",
  "logo": "awsui_logo_k5dlb_1qnfo_184",
  "title": "awsui_title_k5dlb_1qnfo_196",
  "inputs": "awsui_inputs_k5dlb_1qnfo_211",
  "search": "awsui_search_k5dlb_1qnfo_218",
  "search-expanded": "awsui_search-expanded_k5dlb_1qnfo_222",
  "utilities": "awsui_utilities_k5dlb_1qnfo_226",
  "utility-wrapper": "awsui_utility-wrapper_k5dlb_1qnfo_237",
  "utility-type-button-link": "awsui_utility-type-button-link_k5dlb_1qnfo_258",
  "utility-type-menu-dropdown": "awsui_utility-type-menu-dropdown_k5dlb_1qnfo_262",
  "utility-type-button-primary-button": "awsui_utility-type-button-primary-button_k5dlb_1qnfo_270",
  "utility-link-icon": "awsui_utility-link-icon_k5dlb_1qnfo_278",
  "utility-button-external-icon": "awsui_utility-button-external-icon_k5dlb_1qnfo_282",
  "offset-right-none": "awsui_offset-right-none_k5dlb_1qnfo_286",
  "offset-right-l": "awsui_offset-right-l_k5dlb_1qnfo_290",
  "offset-right-xxl": "awsui_offset-right-xxl_k5dlb_1qnfo_294",
  "overflow-menu-drawer": "awsui_overflow-menu-drawer_k5dlb_1qnfo_299",
  "overflow-menu": "awsui_overflow-menu_k5dlb_1qnfo_299",
  "overflow-menu-header": "awsui_overflow-menu-header_k5dlb_1qnfo_319",
  "overflow-menu-header-text": "awsui_overflow-menu-header-text_k5dlb_1qnfo_326",
  "overflow-menu-header-text--secondary": "awsui_overflow-menu-header-text--secondary_k5dlb_1qnfo_337",
  "overflow-menu-header-text--title": "awsui_overflow-menu-header-text--title_k5dlb_1qnfo_343",
  "overflow-menu-back-button": "awsui_overflow-menu-back-button_k5dlb_1qnfo_347",
  "overflow-menu-dismiss-button": "awsui_overflow-menu-dismiss-button_k5dlb_1qnfo_351",
  "overflow-menu-control": "awsui_overflow-menu-control_k5dlb_1qnfo_355",
  "overflow-menu-list-item-utility": "awsui_overflow-menu-list-item-utility_k5dlb_1qnfo_370",
  "overflow-menu-control-link": "awsui_overflow-menu-control-link_k5dlb_1qnfo_377",
  "overflow-menu-control-expandable-menu-trigger": "awsui_overflow-menu-control-expandable-menu-trigger_k5dlb_1qnfo_380",
  "overflow-menu-list": "awsui_overflow-menu-list_k5dlb_1qnfo_370",
  "overflow-menu-list-submenu": "awsui_overflow-menu-list-submenu_k5dlb_1qnfo_411",
  "overflow-menu-list-item": "awsui_overflow-menu-list-item_k5dlb_1qnfo_370",
  "overflow-menu-list-item-icon": "awsui_overflow-menu-list-item-icon_k5dlb_1qnfo_419",
  "overflow-menu-list-item-text": "awsui_overflow-menu-list-item-text_k5dlb_1qnfo_422",
  "overflow-menu-list-item-submenu": "awsui_overflow-menu-list-item-submenu_k5dlb_1qnfo_431",
  "overflow-menu-list-item-dropdown-menu": "awsui_overflow-menu-list-item-dropdown-menu_k5dlb_1qnfo_436",
  "overflow-menu-list-item-expandable": "awsui_overflow-menu-list-item-expandable_k5dlb_1qnfo_439",
  "expanded": "awsui_expanded_k5dlb_1qnfo_447"
};
  